export const SEND_MESSAGE  = 'SEND_MESSAGE';
export const CLOSE_MESSAGE = 'CLOSE_MESSAGE';

export const sendMessage = (message, timeout = 4000) => {
    return (dispatch) => {
        dispatch({
            type   : SEND_MESSAGE,
            message: message,
            timeout: timeout
        });
    }
};

export const closeMessage = () => {
    return (dispatch) => {
        dispatch({ type: CLOSE_MESSAGE });
    }
};



// WEBPACK FOOTER //
// ./src/actions/MessageAction.js